<template>
  <v-card outlined>
    <v-card-subtitle class="pb-1">Blog Görseli *</v-card-subtitle>
    <v-card-text>
      <div
        class="upload-area"
        @click="triggerFileInput"
        :class="{ 'uploading': uploading }"
      >
        <input
          ref="fileInput"
          type="file"
          accept="image/*"
          @change="handleFileSelect"
          style="display: none"
        />

        <div v-if="!uploading && !imageUrl" class="text-center">
          <v-icon large color="primary">cloud_upload</v-icon>
          <p class="mt-2 mb-0">Görsel Yüklemek İçin Tıklayın</p>
          <p class="caption grey--text">JPG, PNG, GIF, WEBP desteklenir</p>
        </div>

        <div v-else-if="uploading" class="text-center">
          <v-progress-circular
            :value="uploadProgress"
            :size="50"
            color="primary"
          >
            {{ Math.round(uploadProgress) }}%
          </v-progress-circular>
          <p class="mt-2 mb-0">Yükleniyor...</p>
        </div>

        <div v-else class="image-preview">
          <v-img
            :src="previewUrl"
            height="200"
            contain
          ></v-img>

          <v-btn
            icon
            small
            color="error"
            class="delete-btn"
            @click.stop="removeImage"
          >
            <v-icon small>delete</v-icon>
          </v-btn>
        </div>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import Api from '@/api/baseApi';
import axios from 'axios';

export default {
  name: 'BlogImageUpload',
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      imageUrl: '',
      previewUrl: '',
      uploading: false,
      uploadProgress: 0
    };
  },
  watch: {
    value: {
      immediate: true,
      handler(newVal) {
        if (newVal && newVal !== this.imageUrl) {
          this.imageUrl = newVal;
          this.loadExistingImage(newVal);
        } else if (!newVal) {
          this.imageUrl = '';
          this.previewUrl = '';
        }
      }
    }
  },
  methods: {
    triggerFileInput() {
      if (!this.uploading) {
        this.$refs.fileInput.click();
      }
    },

    async handleFileSelect(event) {
      const file = event.target.files[0];
      if (!file) return;

      this.uploading = true;
      this.uploadProgress = 0;

      try {
        await this.uploadFile(file);
        this.$emit('input', this.imageUrl);
      } catch (error) {
        console.error('Upload error:', error);
        const errorMessage = error.response && error.response.data && error.response.data.error
          ? error.response.data.error
          : error.message;
        alert('Yükleme hatası: ' + errorMessage);
      } finally {
        this.uploading = false;
        this.uploadProgress = 0;
        this.$refs.fileInput.value = '';
      }
    },

    async uploadFile(file) {
      const presignedResponse = await Api.post('/api/upload/presigned-url-blog', {
        fileName: file.name,
        contentType: file.type
      });

      const { uploadUrl, fileKey } = presignedResponse.data;

      await axios.put(uploadUrl, file, {
        headers: {
          'Content-Type': file.type
        }
      });

      this.uploadProgress = 100;

      const previewUrl = URL.createObjectURL(file);

      this.imageUrl = fileKey;
      this.previewUrl = previewUrl;
    },

    async loadExistingImage(fileKey) {
      try {
        let previewUrl;

        if (fileKey.startsWith('http://') || fileKey.startsWith('https://') || fileKey.startsWith('//')) {
          previewUrl = fileKey;
        } else {
          const response = await Api.post('/api/upload/presigned-download-url', {
            fileKey
          });
          previewUrl = response.data.downloadUrl;
        }

        this.imageUrl = fileKey;
        this.previewUrl = previewUrl;
      } catch (error) {
        console.error('Görsel yükleme hatası:', error);
      }
    },

    removeImage() {
      if (confirm('Bu görseli silmek istediğinize emin misiniz?')) {
        this.imageUrl = '';
        this.previewUrl = '';
        this.$emit('input', '');
      }
    }
  }
};
</script>

<style scoped>
.upload-area {
  border: 2px dashed #1976d2;
  border-radius: 8px;
  padding: 30px;
  cursor: pointer;
  transition: all 0.3s;
  background-color: #f5f5f5;
  min-height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.upload-area:hover:not(.uploading) {
  border-color: #1565c0;
  background-color: #e3f2fd;
}

.upload-area.uploading {
  cursor: not-allowed;
  opacity: 0.7;
}

.image-preview {
  width: 100%;
  position: relative;
}

.delete-btn {
  position: absolute;
  top: 16px;
  right: 16px;
  background-color: rgba(255, 255, 255, 0.9) !important;
  z-index: 10;
}

.delete-btn:hover {
  background-color: rgba(255, 255, 255, 1) !important;
}
</style>
